import { create } from "zustand";

interface FileWithoutIndex {
    [key: string]: any;
}

interface IndexingState {
    filesWithoutIndex: FileWithoutIndex[];
    setFilesWithoutIndex: (filesNoIndex: FileWithoutIndex[]) => void;
}

const indexingStore = create<IndexingState>()((set) => ({
    filesWithoutIndex: [],
    setFilesWithoutIndex: (filesNoIndex: FileWithoutIndex[]) => set({ filesWithoutIndex: filesNoIndex }),
}));

export default indexingStore;